<ion-content color="primary" class="ion-no-padding">
  <ion-fab vertical="top" horizontal="end" slot="fixed">
    <ion-fab-button (click)="close()">
      <ion-icon name="play-skip-forward-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <div class="container">
    <div>
      <ion-img src="/assets/images/logo_cmillonario.svg"></ion-img>
      <ion-progress-bar color="tertiary" type="indeterminate"></ion-progress-bar>
    </div>
  </div>
</ion-content>
